// extracted by mini-css-extract-plugin
export default {"disclaimer":"AS3B3","disclaimerLink":"CKATA"};